const apiUrl = " https://a893-35-73-189-94.ngrok.io";

export default apiUrl;
